"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateReportSettingsParam = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.updateReportSettingsParam = (0, graphql_tag_1.default) `
  mutation UpdateReportSettingsParam(
    $reportParamSettings: UpdateReportParamSettingsInputType!
  ) {
    updateReportSettingsParam(reportParamSettings: $reportParamSettings) {
      id
    }
  }
`;
//# sourceMappingURL=update-report-settings-param.js.map